import PageHandler from "./PageHandler";
import Pages from "Pages";

class HomePageHandler extends PageHandler {
  constructor() {
    super("", Pages.HomePage);
  }
}

export default HomePageHandler;



// WEBPACK FOOTER //
// ./src/Stores/UIStore/PageHandlers/HomePageHandler.js